import { type PropsWithChildren } from 'react';
import { Icon } from '#icons';
import { BannerContent, BannerElement, BannerTitle, BannerBody } from './styles';

export type BannerTypes = string | null;

type BannerProps = {
  title: string;
  type?: BannerTypes;
  scope: string;
};

const BannerIcon = (type: BannerTypes) => {
  switch (type) {
    case 'error':
    case 'warning':
      return (
        <Icon width="20px" height="20px">
          WarningIcon
        </Icon>
      );
    case 'info':
      return (
        <Icon width="20px" height="20px">
          Info
        </Icon>
      );
    default:
      return null;
  }
};

export const Banner = ({
  type = 'info',
  title,
  scope,
  children,
}: PropsWithChildren<BannerProps>) => {
  return (
    <BannerElement
      scope={scope}
      type={type}
      role={type === 'info' ? 'status' : 'alert'}
      aria-live={type === 'info' ? 'polite' : 'assertive'}
    >
      <BannerContent>
        <BannerTitle>
          {BannerIcon(type)}
          {title}
        </BannerTitle>
        <BannerBody>{children}</BannerBody>
      </BannerContent>
    </BannerElement>
  );
};
